import {
  RATE_LIST_REPORT_GO_BUTTON_ACTION,
  RATE_LIST_REPORT_GO_BUTTON_SUCCESS,
  RATE_LIST_REPORT_API_ERROR_ACTION,
} from "./actionType";

const INIT_STATE = {
  Rate_List_ReportGobtn: [],
  goBtnLoding: false,
};

const RateListReportReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RATE_LIST_REPORT_GO_BUTTON_ACTION:
      return {
        ...state,
        goBtnLoding: action.config.btnId,
      };

    case RATE_LIST_REPORT_GO_BUTTON_SUCCESS:
      return {
        ...state,
        Rate_List_ReportGobtn: action.payload,
        goBtnLoding: false,
      };

    case RATE_LIST_REPORT_API_ERROR_ACTION:
      return {
        ...state,
        goBtnLoding: false,
      };

    default:
      return state;
  }
};

export default RateListReportReducer;
